import request from '@/router/axios'

export function fetchList(query) {
    return request({
      url: '/msg/admin/notice/page',
      method: 'get',
      params: query
    })
}

export function fetchUserMsgList(query) {
  return request({
    url: '/msg/admin/messages/page',
    method: 'get',
    params: query
  })
}

export function saveMsg(data) {
  return request({
    url: '/msg/admin/notice/save',
    method: 'POST',
    data
  })
}

export function updateMsg(data) {
  return request({
    url: '/msg/admin/notice/update',
    method: 'put',
    data
  })
}

export function deleteMsg(data) {
  return request({
    url: '/msg/admin/notice/delete',
    method: 'delete',
    params: data
  })
}
